<template>

  <popover-box ref="popover" :parent="parent" :direction="direction">
    <operator-selector v-on:select="selectOperator"></operator-selector>
  </popover-box>

</template>

<script>

import PopoverBox from './PopoverBox'
import OperatorSelector from './OperatorSelector'
import popoverContainerMixin from './popoverContainerMixin'

export default {
  mixins: [
    popoverContainerMixin
  ],
  components: {
    PopoverBox, OperatorSelector
  },
  methods: {
    selectOperator (operator) {
      this.$refs.popover.dismiss()
      this.$emit('select', operator)
    }
  }
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// OperatorPopover.vue?560fc2f6